// // Actions
import { SET_LOCATION_IDS } from '../actionTypes/locations.actionTypes';

// Classes
import { LocationsReducerState } from '../classes/locations.classes';

const initialState = new LocationsReducerState();

export const LocationsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_LOCATION_IDS:
      return { ...state, locationIds: action.payload };
    default:
      return state;
  }
};
